import React from 'react';
import {
  Box,
  Grid,
  Typography,
} from '@mui/material';

import styles from './styles';

import WellboreImage from '../../../assets/images/LandingPage1.png';
import ChartImage from '../../../assets/images/LiveECDBrief.png';

function LiveECD() {
  const classes = styles();

  return (
    <Box className={classes.wrapper}>
      <Grid container spacing={6} alignItems="flex-start">
        <Grid item xs={12} lg={6}>
          <img
            src={WellboreImage}
            alt="Live ECD Wellbore"
            className={classes.wellboreImage}
          />
        </Grid>

        <Grid item xs={12} lg={6} className={classes.contentColumn}>
          <Box className={classes.textContent}>
            <Typography variant="h4" className={classes.sectionTitle}>
              What Is It?
            </Typography>

            <Typography className={classes.paragraph}>
              Premium&apos;s Live ECD system transmits critical ESD/ECD values and
              MPD setpoints to the EDR and the cloud to improve alignment across
              teams (field, office - operations, engineering) to ensure that
              target equivalent mud weight is always maintained (drilling,
              stripping, et cetera).
            </Typography>

            <Typography variant="h4" className={classes.sectionTitle}>
              How Does It Work?
            </Typography>

            <Typography className={classes.paragraph}>
              Premium&apos;s RTOC configures your specific Live ECD (hydraulics
              model) simulation remotely to run at the rig. The Live ECD System
              ingests 1-second data from the rig&apos;s EDR (Pason, TOTCO, OFI,
              et al) to calculate critical ECD/ESD values and MPD setpoints which
              are transmitted to the EDR every second. Premium&apos;s RTOC updates
              the Live ECD system as needed (e.g., mud checks, surveys, trips,
              BHA changes, et cetera).
            </Typography>

            <Typography variant="h4" className={classes.sectionTitle}>
              Why Is It Important?
            </Typography>

            <Typography className={classes.paragraph}>
              The case study below highlights a recent operation in which we used
              the system to hold Landing Point ECD/ESD north of 16.4 and south of
              16.6 (from kickoff point to TD). Once at TD, the rig was able to
              pull without having to wash and ream (please see text message
              exchange between myself and the rig). Other customers use our MPD system
              to maximize ROP and our Live ECD System to monitor ECD/ESD
              (here&apos;s a recent LinkedIn{' '}
              <a
                href="https://www.linkedin.com/posts/bremerson_wearepremium-mpd-valve-activity-7377485428192538624-m7zT/"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.link}
              >
                post
              </a>
              {' '}to that effect).
            </Typography>
          </Box>
          <Box className={classes.chartContainer}>
            <img
              src={ChartImage}
              alt="Live ECD Chart"
              className={classes.chartImage}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default LiveECD;
